import { Card } from '@/components/ui/card'
import { transformCustomEmojisInContent } from '@/lib/draft-event'
import { createFakeEvent } from '@/lib/event'
import { cn } from '@/lib/utils'
import { useMemo } from 'react'
import Content from '../../Content'

export default function Preview({ content, className }: { content: string; className?: string }) {
  const event = useMemo(() => {
    const { content: processedContent, emojiTags } = transformCustomEmojisInContent(content)
    return createFakeEvent({ content: processedContent, tags: emojiTags })
  }, [content])

  return (
    <Card className={cn('p-3', className)}>
      <Content event={event} className="pointer-events-none h-full" mustLoadMedia />
    </Card>
  )
}
